// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__WX5mZ","iconWithCounter":"styles_iconWithCounter__rCrxO","counterForLabel":"styles_counterForLabel__ttBF6","counterForIcon":"styles_counterForIcon__307zl"};